import { useEffect, useRef, useState } from 'react';
import type { RefObject } from 'react';

interface UseIntersectionObserverOptions {
  ref?: RefObject<HTMLElement | null>;
  root?: Element | null;
  rootMargin?: string;
  threshold?: number | number[];
  enabled?: boolean;
}

export const useIntersectionObserver = (options: UseIntersectionObserverOptions = {}) => {
  const { root = null, rootMargin = '0px', threshold = 0, enabled = true } = options;
  const internalRef = useRef<HTMLElement | null>(null);
  const ref = options.ref ?? internalRef;
  const [entry, setEntry] = useState<IntersectionObserverEntry | null>(null);

  useEffect(() => {
    if (!enabled || !ref.current) return;

    const observer = new IntersectionObserver(
      ([observerEntry]) => {
        setEntry(observerEntry);
      },
      { root, rootMargin, threshold }
    );

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [root, rootMargin, threshold, enabled]);

  return {
    ref,
    isIntersecting: entry?.isIntersecting ?? false,
    entry,
  };
};
